<template>
    <div>
        <p class="is-italic has-text-info clarity-mask">
            {{
                translate("audit_logs.template.paymentUpdated", false, [
                    context.eventRegistrationId,
                    context.firstName,
                    context.lastName,
                    context.academyName,
                ])
            }}
        </p>
        <p>
            {{ translate("admin_payment.payment_complete") }}:
            <span class="has-text-weight-bold" :class="context.complete ? 'has-text-success' : 'has-text-danger'">{{
                translateCompleteField(context.complete)
            }}</span
            >, {{ translate("page.pay_online.amount") }}: {{ context.amount }}, {{ translate("admin_payments.payment_status") }}:
            {{ context.paymentStatus }}
            <template v-if="context.discountPercentage">
                , {{ translate("coupons.discount") }}: {{ context.discountPercentage }}%
            </template>
        </p>
    </div>
</template>

<script setup lang="ts">
    import { PaymentUpdated } from "../../Api/auditLogsApi";
    import { translate } from "../../Common/translations";
    import { User } from "../../Common/types";

    defineProps<{
        context: PaymentUpdated;
        user: User;
    }>();

    const translateCompleteField = (complete: boolean): string => {
        return complete ? translate("event_setting_type.bool.true") : translate("event_setting_type.bool.false");
    };
</script>

<style scoped></style>
